import { createContext } from 'react'

export interface ManageSelectedOrgContextProps {
  orgId: string | null
}

export const ManageSelectedOrgContext =
  createContext<ManageSelectedOrgContextProps | null>(null)
